import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService } from '../data.service';
import { FormControl, NgForm, FormGroupDirective, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import { Preinscripcio } from '../lib/model/preinscripcio';
import { Localitat } from '../lib/model/localitat';
import { Pais } from '../lib/model/pais';
import { Utilitats } from '../lib/utilitats';
import { BLComConegut } from '../lib/bl/blcomconegut';
import { ComConegut} from '../lib/model/comconegut';
import { ErrorStateMatcher, MatSnackBar, MatStepper } from '@angular/material';
import { BLPreinscripcio } from '../lib/bl/blpreinscripcio';

@Component({
  selector: 'app-dades-contacte',
  templateUrl: './dades-contacte.component.html',
  styleUrls: ['./dades-contacte.component.css'],
  providers: [BLPreinscripcio]
})
export class DadesContacteComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;

  emailInput = new FormControl('', [Validators.email, Validators.required]);
  preinscripcio: Preinscripcio;
  stepPerformed = false;

  paisCtrl: FormControl;
  poblacioCtrl: FormControl;

  filteredPaisos: Observable<Pais[]>;
  filteredPoblacions: Observable<Localitat[]>;

  constructor(public dataService: DataService,
              public utilitats: Utilitats,
              public blPreinscripcio: BLPreinscripcio,
              public snackBar: MatSnackBar) {

        this.preinscripcio = this.dataService.preinscripcio;

        this.paisCtrl = new FormControl();
        this.filteredPaisos = this.paisCtrl.valueChanges
            .startWith(null)
            .map(x => x ? this.dataService.filtraPaisos(x) : this.dataService.paisos);

        this.poblacioCtrl = new FormControl();
        this.filteredPoblacions = this.poblacioCtrl.valueChanges
            .startWith(null)
            .map(x => {
              if (x != null && x.length > 1) {
                return this.dataService.filtraPoblacions(x);
              } else {
                return this.dataService.poblacions.slice(0, 250);
              }
            });
  }

  async ngOnInit() {

  }

  paisChange(newValue) {
    if (newValue != null && newValue.value) {
      if ((this.preinscripcio.alumne.pais === null) ||
          (this.preinscripcio.alumne.pais.value !== newValue.value)) {
        this.preinscripcio.alumne.pais = newValue;
      }
    } else {
      this.preinscripcio.alumne.pais = null;
    }
  }

  poblacioChange(newValue) {
    if (newValue != null && newValue.value) {
      if ((this.preinscripcio.alumne.poblacio === null) ||
          (this.preinscripcio.alumne.poblacio.value !== newValue.value)) {
        this.preinscripcio.alumne.poblacio = newValue;
      }
    } else {
      this.preinscripcio.alumne.poblacio = null;
    }
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
      // TODO: Tenim una barreja de dos estils, template driven i reactive driven, per això cal validar algunes coses a banda
      if (this.emailInput.invalid && this.emailInput.value !== '') {
        return false;
      }
      if (this.utilitats.isNullOrEmpty(this.preinscripcio.alumne.pais)) {
        return false;
      }
      if (this.preinscripcio.alumne.paisEspanya()) {
        if (this.utilitats.isNullOrEmpty(this.preinscripcio.alumne.poblacio)) {
          return false;
        }
      } else if (this.utilitats.isNullOrEmpty(this.preinscripcio.alumne.poblacioText)) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }

  public async continua() {
    try {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
      if (!this.preinscripcio.isnew) {
        this.preinscripcio = await this.blPreinscripcio.save(this.preinscripcio);
        this.dataService.preinscripcio = this.preinscripcio;
      }
    } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/dades-contacte/dades-contacte.component.ts